export const VERSION = '2.13.1';
export const BRANCH_PREFIX = 'acc';
export const DEPLOY_VERSION = [...VERSION.split('.').slice(0, 2), 'x'].join('.');
